var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5001 13.3333C17.9274 13.3333 18.2797 13.655 18.3278 14.0695L18.3334 14.1667V15.8333C18.3334 17.1647 17.2926 18.253 15.9803 18.3291L15.8334 18.3333H4.16675C2.83535 18.3333 1.74703 17.2926 1.67099 15.9802L1.66675 15.8333V14.1667C1.66675 13.7064 2.03984 13.3333 2.50008 13.3333C2.92744 13.3333 3.27967 13.655 3.32781 14.0695L3.33341 14.1667V15.8333C3.33341 16.2607 3.65512 16.6129 4.06956 16.6611L4.16675 16.6667H15.8334C16.2608 16.6667 16.613 16.345 16.6611 15.9305L16.6667 15.8333V14.1667C16.6667 13.7064 17.0398 13.3333 17.5001 13.3333ZM10.0001 1.66666C10.4603 1.66666 10.8334 2.03975 10.8334 2.49999V10.4875L11.9108 9.41073C12.2112 9.11033 12.6839 9.08722 13.0108 9.34141L13.0893 9.41073C13.3897 9.71114 13.4128 10.1838 13.1587 10.5107L13.0893 10.5892L10.5893 13.0892L10.5527 13.1237L10.4962 13.1697L10.4035 13.2294L10.3095 13.274L10.2217 13.3035L10.098 13.3276L10.0001 13.3333L9.93738 13.331L9.83281 13.3165L9.73996 13.2919L9.6474 13.2553L9.56616 13.2117L9.48612 13.156C9.45969 13.1353 9.43455 13.113 9.41083 13.0892L6.91083 10.5892C6.58539 10.2638 6.58539 9.73617 6.91083 9.41073C7.21123 9.11033 7.68392 9.08722 8.01083 9.34141L8.08934 9.41073L9.16675 10.4875V2.49999C9.16675 2.03975 9.53984 1.66666 10.0001 1.66666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadButtonIcon);
export default __webpack_public_path__ + "static/media/downloadButtonIcon.df28bae1.svg";
export { ForwardRef as ReactComponent };